module.exports = __webpack_public_path__ + "img/svg/team-photo-overlay.c551b75289c518d34104c509f84977a3.svg";